<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_rewards', 2),
                        href: meta.links.index,
                    },
                    {
                        name: reward.title,
                        href: null,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-3 xl:grid-cols-6 md:gap-6">
            <div class="flex flex-col w-40" v-for="image in options.images" :key="image.full_path">
                <div class="text-sm">
                    <div class="flex space-x-2">
                        <label> &nbsp;{{ reward.title }} </label>
                    </div>
                </div>
                <div class="mt-2">
                    <inertia-link
                        method="patch"
                        as="button"
                        :href="meta.links.update"
                        :data="{ attachment_id: image.id }"
                        class="w-full"
                    >
                        <div
                            :class="[reward.is_negative ? 'bg-red-500' : 'bg-indigo-500']"
                            class="shrink-0 flex items-center justify-center h-16 w-full rounded-lg aspect-w-1 aspect-h-1"
                        >
                            <img v-if="image.full_path" :src="image.full_path" alt="" />
                        </div>
                    </inertia-link>
                </div>
                <div class="flex justify-between mt-2">
                    <div>
                        <BadgePill color="green" class="text-lg" v-if="reward.experience_amount !== null">
                            {{ reward.experience_amount }}
                        </BadgePill>
                    </div>
                    <div>
                        <BadgePill color="red" class="text-lg" v-if="reward.health_amount !== null">
                            {{ reward.health_amount }}
                        </BadgePill>
                    </div>
                    <div>
                        <BadgePill color="yellow" class="text-lg" v-if="reward.coins_amount !== null">
                            {{ reward.coins_amount }}
                        </BadgePill>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        PanelPage,
        BadgePill,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'reward', 'gamificationSet'],
    data() {
        return {
            form: this.$inertia.form({
                title: this.reward.title,
                description: this.reward.description,
                experience_amount: this.reward.experience_amount,
                coins_amount: this.reward.coins_amount,
                health_amount: this.reward.health_amount,
                is_negative: this.reward.is_negative,
                creates_foul: this.reward.creates_foul,
                type: this.reward.type,
                severity: this.reward.severity,
            }),
        };
    },
    computed: {
        rewardPreview: function () {
            return {
                title: this.form.title,
                is_negative: this.form.is_negative,
                experience_amount: this.form.experience_amount ? this.form.experience_amount : null,
                coins_amount: this.form.coins_amount ? this.form.coins_amount : null,
                health_amount: this.form.health_amount ? this.form.health_amount : null,
            };
        },
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
